export default "__VITE_ASSET__C8O0h1Ak__"